/**
 * @file store/assistantStore.tsx
 * @description 助手（应用）配置与运行期相关状态：
 * - 保存应用基本信息、工具列表、保存后处理、销毁重置等
 */
import { AssistantDetail } from '@/types/assistant'
import { create } from 'zustand'
import { getAssistantDetailApi } from '../controllers/API/assistant'

/**
 * 助手编辑管理
 */

type State = {
  changed: boolean
  assistantState: AssistantDetail
  toolList: any[]
}

type Action =
  | 'setBaseInfo'
  | 'setting'
  | 'setPrompt'
  | 'setGuideword'
  | 'setTools'
  | 'setFlows'
  | 'setQuestion'
  | 'setDesc'

type Actions = {
  /**
   * 更新助手主状态
   * @param action 逻辑动作标识（setBaseInfo/setting/...）
   * @param assistantState 变更片段（与当前合并）
   */
  dispatchAssistant: (action: Action, assistantState: Partial<AssistantDetail>) => void
  /**
   * 更新工具列表
   * @param action 逻辑动作标识
   * @param data 工具列表
   */
  dispatchToolList: (action: Action, data: any[]) => void
  /**
   * 通过ID拉取助手详情
   * @param id 助手ID
   * @returns Promise<AssistantDetail>
   */
  loadAssistantState: (id: string) => Promise<any>
  /**
   * 聊天页兼容：直接写入数据
   */
  chatloadAssistantState: (data: any) => Promise<any>
  /** 保存后回调（重置 changed 标记） */
  saveAfter: () => void
  /** 清空状态（离开页面时调用） */
  destroy: () => void
}

const assistantReducer = (state: State, action: Action, data: Partial<AssistantDetail>) => {
  console.log('action :>> ', action, data)
  return { changed: true, assistantState: { ...state.assistantState, ...data } }
}

const toolListReducer = (state: State, action: Action, data: any[]) => {
  console.log('toolList action :>> ', action, data)
  return { toolList: data }
}

const assistantTemp = {
  id: 3,
  name: '',
  desc: '',
  logo: '',
  prompt: '',
  guide_word: '',
  guide_question: [],
  model_name: '',
  temperature: 0.5,
  status: 0,
  user_id: 1,
  create_time: '',
  update_time: '',
  tool_ids: [],
  tool_list: [],
  flow_list: [],
  mcp_list: [],
  knowledge_list: [],
  role_save_judgment: '',
  only_chat: 0
} as any

export const useAssistantStore = create<State & Actions>(set => ({
  changed: false,
  assistantState: { ...assistantTemp },
  toolList: [],
  dispatchAssistant: (action: Action, data: Partial<AssistantDetail>) =>
    set(state => assistantReducer(state, action, data)),
  dispatchToolList: (action: Action, data: any[]) => set(state => toolListReducer(state, action, data)),
  // 加载助手状态
  loadAssistantState: id => {
    return getAssistantDetailApi(id).then(data => {
      set({
        assistantState: {
          ...data,
          // 补一个空行
          guide_question: data.guide_question ? [...data.guide_question, ''] : ['']
          // guide_question: data.guide_question
          // ? data.guide_question.length < 10
          //   ? [...data.guide_question, '']
          //   : [...data.guide_question]
          // : ['']
        }
      })
      return data
    })
  },
  // chat 兼容之前逻辑
  chatloadAssistantState: data => {
    set({
      assistantState: {
        ...data,
        guide_question: data.guide_question ? [...data.guide_question, ''] : ['']
      }
    })
    return data
  },
  saveAfter() {
    set({ changed: false })
  },
  destroy: () => {
    set({ assistantState: { ...assistantTemp } })
  }
}))
